// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nzqb","footer":"styles_footer__3wkqj"};